import React from "react";

const IELTSIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 280 81"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.4828 2.70117H0V78.8288H19.4828V2.70117Z" />
    <path d="M27.5312 2.70117H86.3989V18.2674H47.0141V32.2432H86.2925V47.49H47.0141V63.2692H86.6119V78.8288H27.5312V2.70117Z" />
    <path d="M93.875 2.70117H113.464V62.3142H149.249V78.8288H93.875V2.70117Z" />
    <path d="M156.613 18.1611H134.805V2.70459H198.015V18.1611H176.096V78.8323H156.613V18.1611Z" />
    <path d="M217.535 53.5268C217.748 62.2117 222.617 66.6573 231.937 66.6573C240.09 66.6573 244.429 63.7956 244.429 59.137C244.429 56.5948 243.264 54.6914 241.464 53.7364C236.912 51.4071 228.23 49.9264 217.113 45.4774C206.102 41.1516 200.385 33.831 200.385 24.4107C200.385 10.1022 211.699 0.585449 230.772 0.585449C249.297 0.585449 260.627 10.5415 260.627 25.6785H242.326C241.474 18.5842 237.334 15.3032 229.511 15.3032C222.943 15.3032 218.923 18.3712 218.923 22.1846C218.923 27.9046 224.853 29.0693 236.815 32.9858C245.603 35.8442 251.959 37.854 255.663 40.8189C260.654 44.8419 263.183 50.349 263.183 56.9142C263.183 71.7351 251.43 80.9491 230.037 80.9491C210.242 80.9491 199.969 71.9647 198.805 53.5268H217.535Z" />
    <path d="M276.129 11.2598L278.325 4.56145H278.382C278.331 5.63958 278.304 6.30509 278.302 6.55798C278.3 6.81088 278.3 7.03271 278.302 7.22349V11.2598H279.989V2.70801H277.52L275.374 9.24664H275.341L273.334 2.70801H270.865V11.2598H272.486V7.26675C272.486 6.81199 272.448 5.90135 272.372 4.53483H272.426L274.485 11.2432L276.129 11.2598ZM267.278 4.21872H269.607V2.70801H263.148V4.21872H265.478V11.2598H267.291L267.278 4.21872Z" />
  </svg>
);

export default IELTSIcon;
